/**
 * Created by Carsten Bühler
 * User: CBuehler on 12.01.2016
 * Copyright: xdot GmbH 2016
 */

import { ClassRemoteDataStore } from 'plugin/liferay-widgets-react-web';
import { ClassNames } from '../constants/Constants';

export default class JournalStore extends ClassRemoteDataStore {

    constructor(Dispatcher) {
        super(Dispatcher, ClassNames.JournalEntry);
    }

}




// WEBPACK FOOTER //
// ./js/stores/JournalStore.js